var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-l-5 m-b-10" }, [
    _c("div", { staticClass: "m-b-2 m-t-5" }, [
      _c("i", {
        staticClass: "m-t-5 m-r-3 fa",
        class: _vm.iconMapping[_vm.columnName],
        attrs: { "tooltip-placement": "left", "aria-hidden": "true" }
      }),
      _vm._v(" "),
      _c("strong", [_vm._v(_vm._s(_vm.columnDisplayName))])
    ]),
    _vm._v(" "),
    _c(
      "table",
      { staticClass: "table_beauty condensed-alternate routing-plan-args" },
      [
        _c("thead", [
          _c("tr", { staticClass: "bg-transparent" }, [
            _c("th", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "BID_AMOUNT",
                  expression: "'BID_AMOUNT'"
                }
              ],
              staticClass: "text-right routing-plan-args__bid-amount"
            }),
            _vm._v(" "),
            _c("th", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "DURATION",
                  expression: "'DURATION'"
                }
              ],
              staticClass: "text-right routing-plan-args__bid-duration"
            }),
            _vm._v(" "),
            _c("th", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "NAME",
                  expression: "'NAME'"
                }
              ]
            }),
            _vm._v(" "),
            _vm.columnName.toLowerCase() === "notacceptedringtreetargets"
              ? _c("th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "REASON",
                      expression: "'REASON'"
                    }
                  ]
                })
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.parsedCallPlanDetail, function(target, index) {
            return _c("tr", { key: index, staticClass: "bg-transparent" }, [
              _c("td", { staticClass: "text-right" }, [
                target.hasTimedout ? _c("span", [_vm._v("-")]) : _vm._e(),
                _vm._v(" "),
                !target.hasTimedout
                  ? _c("span", [
                      _vm._v(_vm._s(_vm._f("currency")(target.bidAmount)))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-right" }, [
                target.hasTimedout ? _c("span", [_vm._v("-")]) : _vm._e(),
                _vm._v(" "),
                !target.hasTimedout
                  ? _c("span", [_vm._v(_vm._s(target.duration))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "a",
                  {
                    staticClass: "table-ellipsis__name linked-name",
                    attrs: {
                      rel: "noopener",
                      target: "_blank",
                      href: target.targetPage
                    }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(target.name) + "\n          "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.columnName.toLowerCase() === "notacceptedringtreetargets"
                ? _c("td", [
                    _vm._v(
                      "\n          " +
                        _vm._s(target.notAcceptedReason) +
                        "\n        "
                    )
                  ])
                : _vm._e()
            ])
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }